<div class="container-xxxl eula-section">
    <div mat-dialog-title class="mb-0 pb-0">
        <div class="float-start">
            <span class="heading font-family-montserrat">End User License Agreement (EULA)</span>
        </div>
        <div class="float-end">
            <i mat-dialog-close class="fa fa-times" aria-hidden="true"></i>
        </div>
        <div>
            <p class="title">PLEASE READ THE TERMS & CONDITIONS CAREFULLY</p>
        </div>
    </div>
    <div mat-dialog-content>
        <!-- Moved Cards Section -->
        <div class="row">
            <!-- Card -->
            <div class="col-12 font-family-montserrat">
                <div *ngIf="pdfUrl" class="pdf-container">
                    <iframe [src]="pdfUrl" class="pdf-iframe" frameborder="0"></iframe>
                </div>
            </div>
        </div>
    </div>